export { default } from './useModalDelete';
